module.exports = __webpack_public_path__ + "static/media/two.558cfc7d.svg";